import React, { JSX } from 'react'

const HeartIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7839 5.84131C18.7839 3.00889 16.8652 0.710449 14.496 0.710449C13.6853 0.710449 12.9243 0.983889 12.2776 1.45596C12.2733 1.45596 11.5963 1.88418 10.2101 3.4629C8.82823 1.88934 8.15128 1.46112 8.14267 1.45596C7.49591 0.983889 6.7349 0.710449 5.92214 0.710449C3.55933 0.710449 1.64062 3.00889 1.64062 5.84131C1.64062 6.19988 1.66864 6.55587 1.73333 6.8938C2.64956 12.3471 10.2144 17.7153 10.2144 17.7153C10.2144 17.7153 17.7772 12.3523 18.6955 6.89896C18.7538 6.55587 18.7839 6.20504 18.7839 5.84131Z"
      stroke={props.stroke || '#000'}
      fill={props.fill || '#fff'}
      strokeWidth="1.4"
    />
  </svg>
)

export default HeartIcon
